import { Data, List, Misc, ModalUtils, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import ValidationSummary from '@singularsystems/neo-react/dist/ReactComponents/ValidationSummary';
import { NotificationDuration } from '../../../App/Models/NotificationDuration';
import { AppService, Types } from '../../DomainTypes';
import BankAccount from '../../Models/Catalogue/Investments/BankAccount';
import BankAccountBalance from '../../Models/Catalogue/Investments/BankAccountBalance';
import BankAccountBalanceLookupCriteria from '../../Models/Catalogue/Investments/Lookups/BankAccountBalanceLookupCriteria';

@NeoModel
export default class BankAccountVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        public cache = AppService.get(Types.Domain.Services.DataCache),
        private investmentsApiClient = AppService.get(Types.Domain.ApiClients.CatalogueInvestment)) {

        super(taskRunner);
        this.autoDispose(this.criteria.onAnyPropertyChanged(() => this.pageManager.refreshData()));
    }

    public criteria = new BankAccountBalanceLookupCriteria();
    public editingBankAccount: BankAccount | null = null;
    public bankAccounts = new List(BankAccount);
    public addMode: boolean = false;

    public pageManager = new Data.PageManager(this.criteria, BankAccountBalance, this.investmentsApiClient.getBankAccountBalancesPaged, {
        pageSize: 20,
        initialTaskRunner: this.taskRunner,
        fetchInitial: true,
        allowSort: true,
    });

    public async initialise() {
        await this.taskRunner.waitFor(this.loadBankAccounts());
    }

    public back() {
        this.addMode = false;
        this.editingBankAccount = null;
        // this.loadBankAccounts();
    }

    public async loadBankAccounts() {
        const result = await this.investmentsApiClient.getBankAccounts();
        this.bankAccounts.set(result.data);
    }

    public newBankAccount() {
        this.editingBankAccount = new BankAccount();
        this.criteria.reset();
        this.addMode = true;
    }

    public async beginEditBankAccount(bankAccount: BankAccount) {
        this.editingBankAccount = bankAccount;
        this.criteria.bankAccountId = this.editingBankAccount.bankAccountId;
    }

    public async saveBankAccount() {
        if (!this.pageManager.data.isValid) {         
            ModalUtils.showModal("Invalid data",
            <div>
                <div>
                    Cannot continue due to the following issues:
                </div>
                <ValidationSummary model={this.pageManager.data}/>
            </div>, {});
        }
        else {
            this.taskRunner.run(async () => {
                if (this.addMode) {
                    this.editingBankAccount!.bankAccountBalances.push(...this.pageManager.data);
                }
                var response = await this.investmentsApiClient.saveBankAccount(this.editingBankAccount!.toJSObject());
                this.editingBankAccount!.update(response.data);
                if (this.addMode) {
                    this.editingBankAccount!.bankAccountBalances = new List(BankAccountBalance);
                    this.criteria.bankAccountId = this.editingBankAccount!.bankAccountId;
                    this.addMode = false;
                }
                this.loadBankAccounts();
                this.notifications.addSuccess("Saved Successfully", "Bank account saved successfully.", NotificationDuration.Standard);
            });
        }
    }

    public async saveBankAccountBalances() {
        this.taskRunner.run(async () => {            
            var response = await this.investmentsApiClient.saveBankAccountBalances(this.pageManager.data.toJSArray());
            this.pageManager.data.update(response.data);
            this.notifications.addSuccess("Saved Successfully", "Bank account balances saved successfully.", NotificationDuration.Standard);
        });
    }

    public newBankAccountBalance() {
        let newBalance = this.pageManager.data.addNew();
        newBalance.bankAccountId = this.editingBankAccount!.bankAccountId;
    }

    public async deleteBankAccount(bankAccount: BankAccount) {
        if (await ModalUtils.showYesNo(
            `Remove '${bankAccount.values.bankAccountName}'?`,
            `Are you sure you want to remove bank account '${bankAccount.values.bankAccountName}'?`) === Misc.ModalResult.Yes) {
            this.taskRunner.run(async () => {
                await this.investmentsApiClient.deleteBankAccount(bankAccount.bankAccountId);
                this.loadBankAccounts();
                this.notifications.addSuccess("Bank Account Removed", `${bankAccount.values.bankAccountName} has been removed`, NotificationDuration.Standard);
            });
        }
    }
    
    public searchImmediate() {
        // TODO: this.autoRunner.fireImmediate();
    }
}